import { Switch, Typography } from "@mui/material";
import { Fragment, React } from "react";
import TickIcon from "../../../assets/icons/TickIcon";
import CommonButton from "../../../component/Button";
import { HandleSkeletion } from "../../../utils/constants";
import { CustomDiv } from "../../chat-bot/style";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import { CustomizeSpan } from "../../jobs/style";

export default function OurPlan({
  monthData,
  handleChange,
  handleExpand,
  handleClickStripeOpen,
  checked,
  loading,
}) {
  return (
    <CustomDiv>
      <CommonGrid2
        gap={"1rem"}
        flexWrap="wrap"
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        marginTop={"3rem"}
      >
        <Typography variant="h2">Our Plans</Typography>
        <CommonGrid2 display={"flex"} gap={"10px"} alignItems={"center"}>
          <CustomizeSpan fontSize="16px">
            <CustomizeSpan fontWeight={600}>Yearly Plan </CustomizeSpan>
            {/* <CustomizeSpan fontWeight={600} color="#2BC778">
              Save 10%{" "}
            </CustomizeSpan>
            <CustomizeSpan fontWeight="400">
              by subscribing annually
            </CustomizeSpan> */}
          </CustomizeSpan>
          <Switch checked={checked} onChange={handleChange} />
        </CommonGrid2>
      </CommonGrid2>

      <CommonGrid2 container spacing={2} marginTop={"3rem"}>
        {loading ? (
          <HandleSkeletion height={80} width={"100%"} transform={"scale(1)"} />
        ) : (
          <Fragment>
            {monthData &&
              monthData?.all_plans.map((item, index) => (
                <CommonGrid2
                  item
                  key={index}
                  size={{ md: 4, xs: 12, sm: 12 }}
                  border={"1px solid #EAECEE"}
                  sx={{
                    padding: {
                      xs: "10px",
                      sm: "1rem",
                      md: "1rem",
                      lg: "1.5rem",
                    },
                  }}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"1rem"}
                  borderRadius={"1rem"}
                  justifyContent={"space-between"}
                >
                  <CommonGrid2
                    display={"flex"}
                    flexDirection={"column"}
                    gap={"1rem"}
                  >
                    <CommonGrid2
                      display={"flex"}
                      justifyContent={"space-between"}
                      alignItems={"center"}
                    >
                      <Typography variant="h5" color="#7F56D9">
                        {item.name}
                      </Typography>
                      {index === 1 && (
                        <CustomDiv
                          padding="2px 8px"
                          borderRadius="5px"
                          background="#EBE1F9"
                        >
                          <Typography
                            color="#7F56D9"
                            variant="subtitle1"
                            fontWeight={500}
                          >
                            {"Most Popular"}
                          </Typography>
                        </CustomDiv>
                      )}
                    </CommonGrid2>

                    <CustomizeSpan fontSize="28px" fontWeight={700}>
                      {item.yearly_price === null &&
                      item.monthly_price === null ? (
                        "Free"
                      ) : (
                        <Fragment>
                          {checked ? item.yearly_price : item.monthly_price}{" "}
                          {index !== 2 && (
                            <CustomizeSpan color="#A9B4BE" fontSize="14px">
                              /{checked ? "yearly" : "month"}
                            </CustomizeSpan>
                          )}
                        </Fragment>
                      )}
                    </CustomizeSpan>

                    <Typography color="#5B738B">{item?.description}</Typography>

                    {item.expand === "Hide Details" &&
                      item.view_data &&
                      item.view_data?.view_data.map((details, _i) => (
                        <CommonGrid2
                          display={"flex"}
                          alignItems={"center"}
                          gap={"10px"}
                          key={_i}
                        >
                          {item.condition && _i === 0 ? (
                            ""
                          ) : (
                            <CustomDiv>
                              <TickIcon color={"#2BC778"} />
                            </CustomDiv>
                          )}
                          <Typography
                            color="#223548"
                            fontStyle={item.condition && _i === 0 && "italic"}
                            fontWeight={item.condition && _i === 0 && 700}
                          >
                            {details}
                          </Typography>
                        </CommonGrid2>
                      ))}
                    <CommonButton
                      value={item.expand}
                      width={"max-content"}
                      background={"transparent"}
                      boxShadow={"none"}
                      color="#223548"
                      fontWeight={700}
                      borderRadius={"0px"}
                      padding={"0px"}
                      onClick={() => handleExpand(index)}
                      customStyle={{
                        "&:hover": {
                          boxShadow: "none",
                        },
                      }}
                    />
                  </CommonGrid2>

                  <CommonButton
                    marginTop={"1rem"}
                    value={item.buttonName}
                    padding={"10px"}
                    fontWeight={600}
                    disabled={
                      item.disabled ||
                      (checked
                        ? monthData?.current_plan?.name?.includes?.("Yearly") &&
                          item?.name === monthData?.current_plan?.base_name
                        : monthData?.current_plan?.name?.includes?.(
                            "Monthly"
                          ) &&
                          item?.name === monthData?.current_plan?.base_name)
                    }
                    loading={item.loading}
                    onClick={() => handleClickStripeOpen(item, index, checked)}
                  />
                </CommonGrid2>
              ))}
          </Fragment>
        )}
      </CommonGrid2>
    </CustomDiv>
  );
}
